import PageHeading from '~/components/PageHeading';
import { useParams } from 'react-router-dom';
import { useCouponsDetailsQuery } from '~/lib/Queries';
import ExpiresDateInput from '~/components/coupons/ExpiresDateInput';
import React, { useEffect, useState } from 'react';
import DiscountTypeInput from '~/components/coupons/DiscountTypeInput';
import AppliesToInput from '~/components/coupons/AppliesToInput';
import CouponDetailsInput from '~/components/coupons/CouponDetailsInput';
import useBusinessPostApi from '~/lib/useBusinessPostApi';
import useDelete from '~/lib/useDelete';
import DotDotDotMenu from '~/components/DotDotDotMenu';
import CopyIcon from '~/components/icons/CopyIcon';
import useBusinessNavigate from '~/lib/useBusinessNavigate';
import * as Toast from '~/lib/Toast';
import CouponLimitsInput from '~/components/coupons/CouponLimitsInput';
import CouponEditForm from '~/components/coupons/CouponEditForm';
import SectionPicker from '~/components/SectionPicker';
import CouponClientUsage from '~/components/coupons/CouponClientUsage';

const CouponEditPage = ({}) => {
    const { couponId } = useParams();
    const [section, setSection] = useState('edit');

    const isNew = !parseInt(couponId);
    const navigate = useBusinessNavigate();

    const { saveDelete, isDeleting } = useDelete(
        `/coupons/${couponId}/delete`,
        {
            prompt: `Are you sure you want to permanently delete this coupon?`,
        },
    );

    function doDelete() {
        saveDelete().then(() => {
            Toast.success(`Successfully deleted coupon`);
            navigate('/coupons');
        });
    }

    return (
        <div>
            <PageHeading
                crumbs={[{ name: 'Coupons', href: '/coupons' }]}
                heading="Edit Coupon"
                rightContent={
                    !isNew && (
                        <DotDotDotMenu
                            btnClassName="btn-gray-circle"
                            options={[
                                // {
                                //     name: isDuplicating
                                //         ? 'Duplicating...'
                                //         : 'Duplicate',
                                //     icon: <CopyIcon />,
                                //     onClick: doDuplicate,
                                // },
                                {
                                    name: isDeleting ? 'Deleting...' : 'Delete',
                                    onClick: () => doDelete(),
                                    isDelete: true,
                                },
                            ]}
                        />
                    )
                }
            />

            {!isNew && (
                <SectionPicker
                    className="mb-4"
                    value={section}
                    onChange={setSection}
                    options={[
                        { value: 'edit', label: 'Edit' },
                        { value: 'clients', label: 'Clients' },
                    ]}
                />
            )}

            {section === 'edit' && <CouponEditForm couponId={couponId} />}
            {section === 'clients' && <CouponClientUsage couponId={couponId} />}
        </div>
    );
};

export default CouponEditPage;
